import { FormPasswordChange } from './ui/FormPasswordChange'

export default FormPasswordChange
